import React, { useState, useEffect } from "react";
import { Select } from "@windmill/react-ui";
import RoleServices from "services/RoleServices";

const SelectRegionalHead = ({
  register,
  name,
  label,
  selectedRoleId,
  selectedRegionalHeadId, // current form value (optional)
  regional_id = null,    // existing ID to preselect
  setValue,
}) => {
  const [regionalHeads, setRegionalHeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [value, setLocalValue] = useState(""); // local controlled value

  //  Fetch regional heads when role changes
  useEffect(() => {
    async function fetchRegionalHeads() {
      if (!selectedRoleId) {
        setRegionalHeads([]);
        setLocalValue(""); // clear selection
        return;
      }

      setLoading(true);
      try {
        const response = await RoleServices.getRegionalHeads(selectedRoleId);
        setRegionalHeads(response?.data || []);
      } catch (error) {
        console.error("Error fetching regional heads:", error);
        setRegionalHeads([]);
      } finally {
        setLoading(false);
      }
    }

    fetchRegionalHeads();
  }, [selectedRoleId]);

  //  Set initial value if existing ID exists or form value
  useEffect(() => {
    if (regionalHeads.length === 0) return;

    // Priority: existing ID -> selectedRegionalHeadId
    const initialId = regional_id || selectedRegionalHeadId;

    if (!initialId) {
      setLocalValue("");
      setValue(name, "");
      return;
    }

    const match = regionalHeads.find(
      (head) => Number(head.id_employee) === Number(initialId)
    );

    if (match) {
      setLocalValue(Number(initialId));
      setValue(name, Number(initialId));
    } else {
      setLocalValue("");
      setValue(name, "");
    }
  }, [regionalHeads, regional_id, selectedRegionalHeadId, name, setValue]);

  // Handle manual change
  const handleChange = (e) => {
    const selectedVal = Number(e.target.value);
    setLocalValue(selectedVal);
    setValue(name, selectedVal);
  };

  return (
    <Select
      className="border h-10 text-sm focus:outline-none block w-full bg-white dark:bg-white border-transparent focus:bg-white"
      name={name}
      {...register(name, { required: `${label} is required!` })}
      disabled={!selectedRoleId || loading}
      value={value}
      onChange={handleChange}
    >
      <option value="">
        {!selectedRoleId
          ? "Select role first"
          : loading
          ? "Loading..."
          : `Select ${label}`}
      </option>

      {!loading &&
        regionalHeads.map((head) => (
          <option key={head.id_employee} value={Number(head.id_employee)}>
            {head.firstname} {head.lastname} — {head.profile_name}
          </option>
        ))}

      {!loading && regionalHeads.length === 0 && selectedRoleId && (
        <option disabled>No regional heads found</option>
      )}
    </Select>
  );
};

export default SelectRegionalHead;
